module.exports = __webpack_public_path__ + "static/media/my-account.56be49fc.png";